import { Chip, ChipProps } from '@mui/material';
import { CustomPaletteColor } from '../../theme/app.theme';
import { forwardRef, useMemo } from 'react';

interface IProps extends Omit<ChipProps, 'label' | 'color'> {
  label: string;
  color: CustomPaletteColor | string;
  disableCasing?: boolean;
  backgroundColor?: string;
}

export const StatusBadge = forwardRef<HTMLDivElement, IProps>(
  (
    { label, color, disableCasing, backgroundColor, sx, ...props }: IProps,
    ref
  ) => {
    const casedLabel = useMemo(() => {
      if (disableCasing) {
        return label;
      }
      return label;
    }, [disableCasing, label]);

    const chipColor =
      typeof color === 'string' ? undefined : (color as ChipProps['color']);
    const customStyle = useMemo(() => {
      const baseStyle =
        typeof color === 'string'
          ? {
              color: color + ' !important',
              borderColor: color + ' !important',
              backgroundColor: backgroundColor || 'transparent',
            }
          : backgroundColor
          ? { backgroundColor }
          : {};

      return { ...baseStyle, ...sx };
    }, [color, backgroundColor, sx]);

    return (
      <Chip
        ref={ref}
        label={casedLabel}
        variant="outlined"
        size="small"
        color={chipColor}
        sx={customStyle}
        data-testid="status-badge"
        {...props}
      />
    );
  }
);
